import {mthen} from '@freckle/maybe'
import type {SummaryT} from '@freckle/school/ts/common/models/summary'
import {useQueryParamAsString, useQueryParamAsNum} from '@freckle/school/ts/hooks/use-params'
import {parseDefaultIdpsFromQueryParam} from '@freckle/school/ts/manage-teachers/api-helpers/filters'
import type {StudentFilterTagT} from '@freckle/school/ts/manage-teachers/components/student-tab/student-tab'
import {StudentTabContainer} from '@freckle/school/ts/manage-teachers/components/student-tab/student-tab'
import type {Props as StudentTabProps} from '@freckle/school/ts/manage-teachers/components/student-tab/student-tab'

type Props = {
  summary: SummaryT
} & StudentTabProps

const STUDENT_FILTER_TAG: StudentFilterTagT = 'student-filters'

export function StudentTabHandler(props: Props) {
  const {tableParams, summary, ...rest} = props

  // Course filter
  const courseId = useQueryParamAsNum('courseId')
  const courseName = useQueryParamAsString('courseName')
  const course =
    courseId !== null && courseName !== null
      ? {id: courseId, name: decodeURIComponent(courseName)}
      : null

  // Teacher filter
  const teacherId = useQueryParamAsNum('teacherId')
  const teacherName = useQueryParamAsString('teacherName')
  const teacher =
    teacherId !== null && teacherName !== null
      ? {id: teacherId, name: decodeURIComponent(teacherName)}
      : null

  // Grade filter
  const grade = useQueryParamAsNum('grade')

  // Source filter
  const mSource = useQueryParamAsString('source')
  const source = mthen(mSource, s => (s === 'admin' || s === 'non-admin' ? s : null))

  // Table filters
  const studentName = useQueryParamAsString('studentName')
  const sisId = useQueryParamAsNum('sisId')

  const identityProviders = parseDefaultIdpsFromQueryParam(
    useQueryParamAsString('identityProviders'),
    {
      tag: 'for-student',
      ...summary
    },
    {tag: 'summary'}
  )

  const tableParamsWithFilter = {
    ...tableParams,
    additionalFilters: {
      tag: STUDENT_FILTER_TAG,
      course,
      teacher,
      grade,
      source: source as 'admin' | 'non-admin' | null | undefined,
      studentName,
      sisId,
      teacherName,
      identityProviders
    }
  }
  return <StudentTabContainer tableParams={tableParamsWithFilter} summary={summary} {...rest} />
}
